import { __decorate } from "tslib";
import { AnyDecoder, ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { Member } from '../members/Member';
/**
 * Equivalent of KeychainedResponse, but this one is patchable and used by the patchusermembers endpoint
 */
export class KeychainedMembers extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * @deprecated
         * Can get dropped after a few months
         */
        this.keychainItems = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(Member) })
], KeychainedMembers.prototype, "members", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(AnyDecoder), optional: true })
], KeychainedMembers.prototype, "keychainItems", void 0);
//# sourceMappingURL=KeychainedMembers.js.map